module.exports = __webpack_public_path__ + "img/computer1.fe4c439f.gif";